// extracted by mini-css-extract-plugin
module.exports = {"container":"playerNewsContainer_container__mBhC5","contentContainer":"playerNewsContainer_contentContainer__dwimb"};